/* eslint-disable import/prefer-default-export */
import { isNil } from 'lodash';
import { EMPTY_TEXT } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';

export function calcUpperThreshold(value, unit, level = 1) {
  const calcValue = value * (1.0 + (level * 0.1));
  return unit === '%' && calcValue > 100 ? 100 : calcValue;
}

export function calcUnderThreshold(value, unit, level = 1) {
  const calcValue = value * (1.0 - (level * 0.1));
  return unit === '%' && calcValue < 0 ? 0 : calcValue;
}

export function calcThresholdByUnit(value, unit) {
  // const unitData = getUnitData(unit);
  return convertValuByUnit(value, unit, false, true, false, 2);
  // return convertValueWithMetricPrefix(value, unit, 0, unitData.divisor, null, false, true);
}

/**
 * 상한 임계치 formatter
 * @author Ju
 * @param  {[type]} data [description]
 * @return {[type]}      [description]
 */
export function formatterForUpperValue(value, unit) {
  if (isNil(value)) {
    return EMPTY_TEXT;
  }
  return calcThresholdByUnit(calcUpperThreshold(value, unit), unit, false, false, false, 0);
}

/**
 * 하한 임계치 formatter
 * @author Ju
 * @param  {[type]} data [description]
 * @return {[type]}      [description]
 */
export function formatterForUnderValue(value, unit) {
  if (isNil(value)) {
    return EMPTY_TEXT;
  }
  return calcThresholdByUnit(calcUnderThreshold(value, unit), unit, false, false, false, 0);
}



// WEBPACK FOOTER //
// ./src/views/settings/operation/BasicInfoSettings/EventPredictSetting/GuideSetting/utils/threshold-guide.js